import { Directive, Inject, Input, OnChanges } from 'angular-ts-decorators';
import { TranslationKey } from './translation-key.enum';
import { ITranslationService } from './translation.service';

@Directive({
  selector: '[systemDictionary]',
})
export class SystemDictionaryDirective implements OnChanges {
  public static $inject: ReadonlyArray<string> = ['$element', 'translation'];

  @Input('@') public systemDictionary?: string | TranslationKey;

  constructor(
    @Inject('$element') private $element: JQLite,
    @Inject('translation') private translation: ITranslationService
  ) {
  }

  public ngOnChanges() {
    const value: string | TranslationKey = this.translation.getSystem(this.systemDictionary);
    this.$element.empty().html(value);
  }
}
